<template>
	<div>
		<el-card class="box-card">
			<channel-data-trend-pic></channel-data-trend-pic>
			<channel-data-detail></channel-data-detail>
		</el-card>
	</div>
</template>

<script>
import ChannelDataDetail from './children/channelDataDetail'
import ChannelDataTrendPic from './children/channelDataTrendPic'
import BasicPager from '../../mixins/BasicPager'
export default {
  name: 'channel-data-trend',
  extends: BasicPager,
  data: function () {
    return {
      datas: []
    }
  },
  components: {
    ChannelDataDetail,
    ChannelDataTrendPic
  },
  methods: {
  }
}
</script>

<style media="screen">

</style>
